import { postData } from "../common/Apicall";

export const addCompanyOverviewApi = (companyOverview , features ) => {
    return postData("/api/v1/web-store/addOverview", { companyOverview , features });
};

export const addAboutUsSectionApi = (aboutUs ) => {
    return postData("/api/v1/web-store/addAbout", { aboutUs });
};

export const toggleProductApi = (addedTop, isVisible)=>{
    return postData("/api/v1/web-store/toggleProductStatus", {addedTop, isVisible})
}

export const getWebStoreDetailsApi = (webStoreID)=>{
    return postData("/api/v1/web-store/getWebStoreDetails", {webStoreID})
}

export const addBannerImagesApi = (data) => {
  const { images, ...allData } = data;

  const formData = new FormData();

  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const value = data[key];
      if (value !== null) formData.append(key, value);
    }
  }

  images.forEach((blob) => {
    formData.append("bannerImages", blob);
  });
  

  return postData("/api/v1/web-store/addBannerImages", formData, true);
};


// export const addBannerImagesApi = (bannerImages, webStoreID) => {
//   return postData("", {
//     webStoreID,
//     bannerImages,
//   });
// };

export const addUpdateBannerImagesApi = (
  bannerImages,
  webStoreID,
  toDeleteImages
) => {
  return postData("/api/v1/web-store/updateBannerImages", {
    webStoreID,
    bannerImages,
    toDeleteImages,
  });
};
